/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：13__part-11
 */

"use strict"

import { createContext } from /* 0 */"react"
import * as /* [auto-meaningful-name] */Module_27 from /* 27 */"../27"
import * as /* [auto-meaningful-name] */Module_39 from /* 39 */"../39"
import * as /* [auto-meaningful-name] */Module_58 from /* 58 */"../58/index"
import * as /* [auto-meaningful-name] */Module_59 from /* 59 */"../59/index"
var pe = createContext({
  draggedItemIndex: -1
})
var /* [auto-meaningful-name] */pe$Consumer = pe.Consumer
var /* [auto-meaningful-name] */pe$Provider = pe.Provider
export { pe$Consumer as fe }
export { pe$Provider as he }
